import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/race-tracker/components/ui/dialog';
import { Input } from '@/race-tracker/components/ui/input';
import { Label } from '@/race-tracker/components/ui/label';
import { Button } from '@/race-tracker/components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/race-tracker/components/ui/select';
import { MEDIA_TYPES } from '@/big-political-list/lib/stationUtils';

const EMPTY = { media_type: 'Broadcast', rep_firm: '', manager: '', title: '', email: '', office_phone: '', contact_mobile: '' };

export default function ManagerFormModal({ open, onClose, manager, onSave, saving }) {
  const [form, setForm] = useState(EMPTY);

  useEffect(() => {
    setForm(manager ? { ...EMPTY, ...manager } : EMPTY);
  }, [manager, open]);

  const set = (f, v) => setForm(p => ({ ...p, [f]: v }));
  const isEdit = !!manager?.id;

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>{isEdit ? 'Edit Manager' : 'Add Manager'}</DialogTitle>
        </DialogHeader>
        <form onSubmit={e => { e.preventDefault(); onSave(form); }} className="space-y-4">
          <div>
            <Label className="text-xs font-medium text-muted-foreground">Media Type *</Label>
            <Select value={form.media_type} onValueChange={v => set('media_type', v)}>
              <SelectTrigger className="mt-1">
                <SelectValue placeholder="Select media type" />
              </SelectTrigger>
              <SelectContent>
                {MEDIA_TYPES.map(t => <SelectItem key={t} value={t}>{t}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <Label className="text-xs font-medium text-muted-foreground">Rep Firm *</Label>
              <Input value={form.rep_firm} onChange={e => set('rep_firm', e.target.value)} required className="mt-1" />
            </div>
            <div>
              <Label className="text-xs font-medium text-muted-foreground">Manager *</Label>
              <Input value={form.manager} onChange={e => set('manager', e.target.value)} required className="mt-1" />
            </div>
            <div>
              <Label className="text-xs font-medium text-muted-foreground">Title</Label>
              <Input value={form.title} onChange={e => set('title', e.target.value)} className="mt-1" />
            </div>
            <div>
              <Label className="text-xs font-medium text-muted-foreground">Email</Label>
              <Input value={form.email} onChange={e => set('email', e.target.value)} className="mt-1" />
            </div>
            <div>
              <Label className="text-xs font-medium text-muted-foreground">Office Phone</Label>
              <Input value={form.office_phone} onChange={e => set('office_phone', e.target.value)} className="mt-1" />
            </div>
            <div>
              <Label className="text-xs font-medium text-muted-foreground">Cell</Label>
              <Input value={form.contact_mobile} onChange={e => set('contact_mobile', e.target.value)} className="mt-1" />
            </div>
          </div>
          <DialogFooter className="gap-2">
            <Button type="button" variant="outline" onClick={() => onClose(false)}>Cancel</Button>
            <Button type="submit" disabled={saving} className="bg-primary text-primary-foreground hover:bg-primary/90">
              {saving ? 'Saving…' : isEdit ? 'Save Changes' : 'Add Manager'}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
